import { useEffect } from 'react';
import { NOOP } from '../../utils/const.js';
import { getRandomId } from '../Utils/baseComponentHelper.js';

const PH_CLASS_PREFIX = 'modal-ph-';
/**
 * Add modal-open class to body.
 * It also adds a placeholder class to remember who added the modal-open class.
 * This will be useful when it will remove the class.
 * @param {object} win browser window (only for test)
 * @param {object} doc browser document (only for test)
 * @returns The placeholder class.
 */
function addModalOpenClassToBody(win = window, doc = document) {
    if (win.innerHeight < doc.documentElement.scrollHeight) {
        const phClass = `${PH_CLASS_PREFIX}${getRandomId()}`;
        if (!doc.body.classList.contains('modal-open')) {
            doc.body.classList.add('modal-open');
        }
        doc.body.classList.add(phClass);
        return phClass;
    }
    return undefined;
}
/**
 * Remove modal-open class to body if this is the last modal.
 * If the component is the last modal, there aren't any other 'modal-ph-XXX' classes.
 * @param {string} phClass the placeholder class name. It stats with 'modal-ph-'.
 * @param {object} doc browser document (only for test)
 */
function removeModalOpenClassToBody(phClass, doc = document) {
    if (phClass !== undefined) {
        doc.body.classList.remove(phClass);
        if (doc.body.className && !doc.body.className.includes(PH_CLASS_PREFIX)) {
            doc.body.classList.remove('modal-open');
        }
    }
}
/**
 * Create a new element as a body child.
 */
function useBodyModalOpenClass(open) {
    useEffect(() => {
        if (!open)
            return NOOP;
        const myClass = addModalOpenClassToBody();
        return () => {
            removeModalOpenClassToBody(myClass);
        };
    }, [open]);
}

export { addModalOpenClassToBody, useBodyModalOpenClass as default, removeModalOpenClassToBody };
